import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SignWrite from "@/views/mine/userData/SignWrite.vue";
import { getPersonalInfo, updatePersonInfo } from "@/api/personalCenter/personalInfo";
import { sysFileUpload, sysFileDelete } from "@/api/managementCenter/otherApi";
import { validatePhone, validateEmail } from "@/util/validate";
import { encryptionNew } from "@/util/utils";
export default {
  name: "UserData",
  components: {
    SignWrite: SignWrite
  },
  props: [],
  data: function data() {
    var vali_phone = function vali_phone(rule, value, callback) {
      if (value) {
        if (validatePhone(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的手机号码"));
        }
      } else {
        callback();
      }
    };

    var vali_mail = function vali_mail(rule, value, callback) {
      if (value) {
        if (validateEmail(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱"));
        }
      } else {
        callback();
      }
    };

    return {
      showWriteView: false,
      loading: false,
      isSuccess: false,
      rules: {
        mobile: [{
          validator: vali_phone,
          trigger: "blur"
        }],
        email: [{
          validator: vali_mail,
          trigger: "blur"
        }]
      },
      fixedUserInfo: {
        avatar: "",
        type: "",
        typeName: "",
        sex: "",
        sexName: "",
        dept: "",
        name: "",
        userCode: "",
        userId: "",
        username: ""
      },
      userInfo: {
        address: "",
        email: "",
        homePhone: "",
        mobile: "",
        officePhone: "",
        personSign: "",
        phone: "",
        postcode: "",
        wxNo: ""
      }
    };
  },
  mounted: function mounted() {
    this.getPersonInfo();
  },
  destroyed: function destroyed() {},
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.savePersonInfo();
        } else {
          return false;
        }
      });
    },
    savePersonInfo: function savePersonInfo() {
      var _this2 = this;

      this.loading = true;
      var params = encryptionNew(JSON.stringify(this.userInfo), "5LiN6KaB56C06Kej");
      updatePersonInfo({
        encrypt: params
      }, this.fixedUserInfo.userId).then(function (_ref) {
        var data = _ref.data;
        _this2.loading = false;

        if (data.code == 0) {
          _this2.$message.success("保存个人信息成功！");

          _this2.getPersonInfo();
        } else {
          _this2.$message.warning(data.msg || "保存个人信息失败！");
        }
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    getPersonInfo: function getPersonInfo() {
      var _this3 = this;

      this.loading = true;
      getPersonalInfo().then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.isSuccess = true;
          var info = data.data || {};
          _this3.fixedUserInfo = _objectSpread({}, info);

          for (var key in _this3.userInfo) {
            _this3.userInfo[key] = info[key] || "";
          }
        } else {
          _this3.$message.warning(data.msg || "获取个人信息失败！");
        }
      }).catch(function (err) {
        _this3.loading = false;
      });
    },
    base64ToFile: function base64ToFile(Base64, filename) {
      var arr = Base64.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mime
      });
    },
    setWriteImg: function setWriteImg() {
      var _this4 = this;

      var base64Str = this.$refs.writeView.getWriteImg();
      var file = this.base64ToFile(base64Str, "aaa.png");
      var fd = new FormData();
      fd.append("fromTarget", 0);
      fd.append("file", file); //上传到后台

      this.loading = true;
      sysFileUpload(fd).then(function (_ref3) {
        var data = _ref3.data;
        _this4.loading = false;

        if (data.code == 0) {
          _this4.userInfo.personSign = data.data.url;

          _this4.$nextTick(function () {
            _this4.showWriteView = false;
          });

          _this4.$message.success("上传签名成功!");
        } else {
          _this4.$message.warning(data.msg || "上传签名失败!");
        }
      }).catch(function (err) {
        _this4.$message.error("上传签名异常!");

        _this4.loading = false;
      });
    },
    clearWrite: function clearWrite() {
      this.$refs.writeView.overwrite();
    }
  }
};